
import React      from 'react';
import CSSModules from 'react-css-modules';
import Dropzone   from 'react-dropzone';

import PresenterName    from '../PresenterName';
import Button           from '../Button';
import FontIcon         from '../FontIcon';
import Overlay          from '../Overlay';
import YesNoOptionPanel from '../YesNoOptionPanel';
import PresenterForm    from '../PresenterForm';

import * as presenterListActions from '../../actions/presenterList';

import { PRESENTER_PICTURE_ENDPOINT, generateEndpoint } from '../../services/endpoints';

import { connect } from 'react-redux';

import style from './style.scss';

class PresenterList extends React.Component {

    componentDidMount() {

        this.props.refreshPresenters();
    }

    _getPresenterImageEndpoint(id) {
        
        const cacheBustParam = '?' + new Date().getTime();

        return generateEndpoint(PRESENTER_PICTURE_ENDPOINT, { id }) + cacheBustParam;
    }

    _getDeletePresenterOverlayContent() {

        if (this.props.isDeleteOverlayOpen) {

            const { presenterToDelete } = this.props;

            return (
                <div>

                    <p>
                        Are you sure you want to to delete the presenter&nbsp;

                        <span styleName="presenter-to-delete">
                            { presenterToDelete.name }
                        </span>?
                    </p>

                    <YesNoOptionPanel no={ this.props.hideDeletePresenterOverlay }
                                      yes={ this.props.deletePresenter.bind(this, presenterToDelete.id) } />

                </div>
            );
        }
    }

    _getDeletePictureOverlayContent() {

        if (this.props.deletingPictureOfPresenter) {

            const presenter = this.props.deletingPictureOfPresenter;

            return (
                <div>

                    <p>
                        Are you sure you want to to delete the picture of&nbsp;

                        <span styleName="presenter-to-delete">
                            { presenter.name }
                        </span>?
                    </p>

                    <YesNoOptionPanel no={ this.props.hideDeletePictureOverlay }
                                      yes={ this.props.deletePresenterPicture.bind(this, presenter.id) } />

                </div>
            );
        }
    }

    _showProfilePicturePicker(presenter) {

        this.props.changePictureOfPresenter(presenter);

        this.dropzone.open();
    }

    _profilePictureSelected(presenter, files) {

        this.props.uploadProfilePicture(presenter.id, files[0]);
    }

    _getRemovePictureOption(presenter) {

        if (presenter['profile_picture']) {

            return (
                <div styleName="remove-picture-option">
                    <span styleName="picture-link__separator">&nbsp;|&nbsp;</span>

                    <a onClick={ this.props.showDeleteProfilePictureOverlay.bind(this, presenter) }
                    styleName="picture-link">

                        Remove
                    </a>
                </div>
            );
        }
    }

    render() {

        return (

            <article>

                <Overlay isOpen={ this.props.isDeletePictureOverlayOpen }
                         closeOverlay={ this.props.hideDeletePictureOverlay }
                         title="Delete Picture"
                         size="small">

                    { this._getDeletePictureOverlayContent() }

                </Overlay>

                <Overlay isOpen={ this.props.isDeleteOverlayOpen }
                         closeOverlay={ this.props.hideDeletePresenterOverlay }
                         title="Delete Presenter"
                         size="small">

                    { this._getDeletePresenterOverlayContent() }

                </Overlay>

                <Button onClick={ this.props.showAddPresenterOverlay.bind(this) }
                        styleName="new-presenter-button">

                    <FontIcon textPosition="right" iconName="plus" />
                    <span>New presenter</span>

                </Button>

                <Overlay isOpen={ this.props.isAddOverlayOpen }
                         closeOverlay={ this.props.hideAddPresenterOverlay }
                         title="Add Presenter"
                         size="medium">

                    <PresenterForm cancel={ this.props.hideAddPresenterOverlay.bind(this) }
                                   submitSuccess={ this.props.addPresenterSuccess.bind(this) } />

                </Overlay>

                <Overlay isOpen={ this.props.isEditOverlayOpen }
                         closeOverlay={ this.props.hideEditPresenterOverlay }
                         title="Edit Presenter"
                         size="medium">

                    <PresenterForm cancel={ this.props.hideEditPresenterOverlay.bind(this) }
                                   submitSuccess={ this.props.editPresenterSuccess.bind(this) } />

                </Overlay>

                <Dropzone ref={ (elem) => this.dropzone = elem }
                          className={ style['dropzone'] }
                          multiple={ false }
                          accept={ 'image/*' }
                          onDrop={ this._profilePictureSelected.bind(this, this.props.changingPictureOfPresenter) } />

                <section>

                    {
                        this.props.presenters.map((presenter) => {

                            const pictureUrl = this._getPresenterImageEndpoint(presenter.id);

                            return (

                                <article key={ presenter.id } styleName="presenter-panel">

                                    <div styleName="portrait-panel">

                                        <img src={ pictureUrl } styleName="portrait" />

                                        <a onClick={ this._showProfilePicturePicker.bind(this, presenter) }
                                           styleName="picture-link">

                                            Change
                                        </a>

                                        { this._getRemovePictureOption(presenter) }

                                    </div>

                                    <div styleName="bio-panel">

                                        <div styleName="bio-action-panel">

                                            <a onClick={ this.props.showEditPresenterOverlay.bind(this, presenter) }
                                               styleName="bio-action">

                                                <span>Edit</span>
                                            </a>

                                            <a onClick={ this.props.showDeletePresenterOverlay.bind(this, presenter) }
                                               styleName="bio-action">

                                                <span>Delete</span>
                                            </a>

                                        </div>

                                        <PresenterName className={ style['presenter-name'] }>
                                            { presenter.name }
                                        </PresenterName>

                                        <div styleName="bio-text"
                                             dangerouslySetInnerHTML={{ __html: presenter.bio }}>
                                        </div>

                                    </div>

                                </article>
                            );
                        })
                    }

                </section>

            </article>
        );
    }
}

function mapStateToProps(state) {

    return state.presenterList;
}

function mapDispatchToProps(dispatch) {

    return {
        deletePresenterPicture: (presenterId) => {

            dispatch(presenterListActions.deletePresenterPicture(presenterId));
        },
        hideDeletePictureOverlay: () => {

            dispatch(presenterListActions.hideDeletePictureOverlay());
        },
        showDeleteProfilePictureOverlay: (presenter) => {

            dispatch(presenterListActions.showDeleteProfilePictureOverlay(presenter));
        },
        changePictureOfPresenter: (presenter) => {

            dispatch(presenterListActions.changePictureOfPresenter(presenter));
        },
        uploadProfilePicture: (presenterId, file) => {

            dispatch(presenterListActions.uploadProfilePicture(presenterId, file));
        },
        showAddPresenterOverlay: () => {

            dispatch(presenterListActions.showAddPresenterOverlay());
        },
        hideAddPresenterOverlay: () => {

            dispatch(presenterListActions.hideAddPresenterOverlay());
        },
        showEditPresenterOverlay: (presenter) => {

            dispatch(presenterListActions.showEditPresenterOverlay(presenter));
        },
        hideEditPresenterOverlay: () => {

            dispatch(presenterListActions.hideEditPresenterOverlay());
        },
        addPresenterSuccess: () => {

            dispatch(presenterListActions.hideAddPresenterOverlay());
            dispatch(presenterListActions.refreshPresenters());
        },
        editPresenterSuccess: () => {

            dispatch(presenterListActions.hideEditPresenterOverlay());
            dispatch(presenterListActions.refreshPresenters());
        },
        deletePresenter: (presenterId) => {

            dispatch(presenterListActions.deletePresenter(presenterId));
        },
        showDeletePresenterOverlay: (presenter) => {

            dispatch(presenterListActions.showDeletePresenterOverlay(presenter));
        },
        hideDeletePresenterOverlay: () => {

            dispatch(presenterListActions.hideDeletePresenterOverlay());
        },
        refreshPresenters: () => {

            dispatch(presenterListActions.refreshPresenters());
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(PresenterList, style));


// WEBPACK FOOTER //
// ./components/PresenterList/index.js